import { createSlice } from "@reduxjs/toolkit";

const INIT_STATE = {
  surveyData: {},
  fleetData: {},
  jobberData: {},
  countryData: {},
};

export const surveyData = createSlice({
  name: "surveyData",
  initialState: INIT_STATE,
  reducers: {
    addItemInsurveyData: (state, action) => {
      state.surveyData = action.payload;
    },
    addItemInFleetData: (state, action) => {
      state.fleetData = action.payload;
    },
    addItemInJobberData: (state, action) => {
      state.jobberData = action.payload;
    },
    addItemInCountryData: (state, action) => {
      state.countryData = action.payload;
    },
  },
});
export const {
  addItemInsurveyData,
  addItemInFleetData,
  addItemInJobberData,
  addItemInCountryData,
} = surveyData.actions;

export default surveyData.reducer;
